export interface ApiErrorDetail {
  path?: string
  message: string
}

export class ApiError extends Error {
  readonly status: number
  readonly code: string
  readonly details: unknown

  constructor(status: number, code: string, message: string, details?: unknown) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
    this.details = details
  }

  static from(
    response: Pick<Response, 'status' | 'statusText'> | undefined,
    body: unknown,
  ): ApiError {
    const payload = (
      body as { error?: { code?: string; message?: string; details?: unknown } } | undefined
    )?.error
    return new ApiError(
      response?.status ?? 0,
      payload?.code ?? (response ? 'HTTP_ERROR' : 'NETWORK_ERROR'),
      payload?.message ||
        response?.statusText ||
        (response ? `HTTP ${response.status}` : 'Network error'),
      payload?.details,
    )
  }

  get fieldErrors(): ApiErrorDetail[] {
    return Array.isArray(this.details) ? (this.details as ApiErrorDetail[]) : []
  }
}

export function isApiError(error: unknown, status?: number): error is ApiError {
  return error instanceof ApiError && (status === undefined || error.status === status)
}

export function isAbortError(error: unknown) {
  return (error as { name?: string } | null)?.name === 'AbortError'
}

export function isTransientError(error: unknown) {
  if (isAbortError(error)) return false
  const status = (error as { status?: number } | null)?.status
  return !status || status >= 500
}
